<template>
  <div class="alert bg-orange-200">
    <div class="container flex items-center gap-4">
      <div class="w-full py-3">
        <Transition name="fade" mode="out-in">
          <div
            class="child:text-orange-900"
            v-if="isOpen"
            v-html="data.alertMessage"></div>
          <div class="child:text-orange-900" v-else>
            <p>{{ data.closedMessage }}</p>
          </div>
        </Transition>
      </div>
      <div class="shrink-0 py-3" v-if="data.isCloseable">
        <button class="p-1" @click="btnClick">
          <span class="sr-only">Close alert</span>
          <Plus
            class="info-icon h-8 w-8 transition-all duration-300"
            :class="{ 'rotate-45': isOpen }" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Plus from "../Svgs/Icons/Plus.vue";

import { ref } from "vue";
import { cookie as Cookie } from "@virginia529/js-helpers";
import { convertToHash, stripHTMLTags } from "../../compostables/useHelpers";
// import { SlideUpDownWithFade } from "@akrug-va529/animations";

export default {
  components: {
    Plus,
  },

  props: {
    data: Object,
  },

  directives: {
    expand: {
      mounted: (el, binding) => {
        if (binding.value !== null) {
          function calcHeight() {
            const currentState = el.getAttribute("aria-expanded");
            el.classList.add("u-no-transition");
            el.removeAttribute("aria-expanded");
            el.style.height = null;
            el.style.height = el.clientHeight + "px";
            el.setAttribute("aria-expanded", currentState);
            setTimeout(function () {
              el.classList.remove("u-no-transition");
            });
          }
          el.classList.add("expand");
          el.setAttribute("aria-expanded", binding.value ? "true" : "false");
          calcHeight();
          window.addEventListener("resize", calcHeight);
        }
      },
      updated: (el, binding) => {
        if (el.style.height && binding.value !== null) {
          el.setAttribute("aria-expanded", binding.value ? "true" : "false");
        }
      },
      //   beforeUpdate: () => {
      //     console.log('beforeUpdate');
      //   }
    },
  },

  setup(props) {
    const openMessage = ref(null);
    const closedMessage = ref(null);
    const cookieValue = convertToHash(
      stripHTMLTags(props.data.alertMessage)
    ).toString();
    const cookieName = "alert" + cookieValue;
    const cookie = Cookie.get(cookieName);

    const cookieExpireTime =
      props.data.lengthOfCloseTime > 0 ? props.data.lengthOfCloseTime : 20160;
    let isOpen = ref(true);

    if (
      cookie !== false &&
      cookie.value === cookieValue &&
      props.data.isCloseable
    ) {
      isOpen.value = false;
    }

    const btnClick = () => {
      isOpen.value = !isOpen.value;

      // Set cookie
      if (isOpen.value) {
        Cookie.remove(cookieName);
      } else {
        Cookie.set(cookieName, cookieValue, cookieExpireTime);
      }
    };

    function onEnter(el, done) {
      // var getHeight = function () {
      //   el.style.display = "block"; // Make it visible
      //   var height = el.scrollHeight + "px"; // Get it's height
      //   el.style.display = ""; // Hide it again
      //   return height;
      // };
      // var height = getHeight(); // Get the natural height
      // el.classList.add("is-visible"); // Make the element visible
      // el.style.height = height; // Update the max-height
      // done();
    }

    function onLeave(el, done) {
      // console.log("onLeave ", el, el.scrollHeight);
      // el.style.height = el.scrollHeight + "px";

      // Set the height back to 0
      // window.setTimeout(function () {
      //   el.style.height = "0";
      // }, 1);

      // // When the transition is complete, hide it
      // window.setTimeout(function () {
      //   el.classList.remove("is-visible");
      // }, 350);

      done();
    }

    return {
      onEnter,
      onLeave,
      btnClick,
      openMessage,
      closedMessage,
      isOpen,
    };
  },
};
</script>

<style>
/* .expand {
  overflow: hidden;
  transition: all 700ms ease;
}
.expand[aria-expanded="false"] {
  height: 0 !important;
}

.u-no-transition {
  transition-duration: 0s !important;
} */

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

.fade-enter-active,
.fade-leave-active {
  transition: all 150ms ease;
}
</style>
